import { render, staticRenderFns } from "./StandoutCard.vue?vue&type=template&id=0894cd4c"
import script from "./StandoutCard.vue?vue&type=script&lang=js"
export * from "./StandoutCard.vue?vue&type=script&lang=js"
import style0 from "./StandoutCard.vue?vue&type=style&index=0&id=0894cd4c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0894cd4c')) {
      api.createRecord('0894cd4c', component.options)
    } else {
      api.reload('0894cd4c', component.options)
    }
    module.hot.accept("./StandoutCard.vue?vue&type=template&id=0894cd4c", function () {
      api.rerender('0894cd4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Card/StandoutCard.vue"
export default component.exports